module.exports = __webpack_public_path__ + "static/media/Pic-0462.3e9785f2.jpg";